// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Typography} from '@material-ui/core';
import {colors} from '../../../../../../assets/styles/colors';
import {CheckCircle, RadioButtonUnchecked} from '@material-ui/icons';

import CustomButton from '../../../../../../elements/CustomButton/CustomButton';

import tableGuide from '../../../../../../assets/img/product-page/image-guide.svg';

import type {SizeChart} from '../../../../../my-store/product-page/duck';
import type {Theme} from '@material-ui/core';

//TODO: change type
type Props = {
  sizeChart: SizeChart,
  selected: boolean,
  handleSelect: (value: string) => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  sizeGuiteItem: {
    border: `1px solid ${colors.grey300}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '16px',
  },
  name: {
    color: colors.grey800,
    fontWeight: 600,
    fontSize: 14,
  },
  selected: {
    borderColor: colors.purple,
  },
}));
export default function SizeGuideItem(props: Props) {
  const {sizeChart, selected, handleSelect} = props;
  const classes = useStyles();

  const checkedCheckbox = (
    <CheckCircle color="primary" style={{fontSize: '1.75rem'}} />
  );
  const uncheckedCheckbox = (
    <RadioButtonUnchecked style={{fontSize: '1.75rem', color: '#D4D4DD'}} />
  );

  return (
    <CustomButton
      fullWidth
      className={`${classes.sizeGuiteItem} ${selected ? classes.selected : ''}`}
      startIcon={selected ? checkedCheckbox : uncheckedCheckbox}
      onClick={() => handleSelect(sizeChart.id)}
    >
      <div className={classes.content}>
        <img src={tableGuide} alt="table sizeChart" />
        <Typography className={classes.name} align="left">
          {sizeChart.name}
        </Typography>
      </div>
    </CustomButton>
  );
}

SizeGuideItem.propTypes = {
  sizeChart: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  handleSelect: PropTypes.func.isRequired,
};
